import React from "react";
import PropTypes from "prop-types";

/**
 * Componente TabContent
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do wrapper de abas.
 * @param {number} [props.padding=3] - O tamanho da margem para o conteúdo das abas.
 * @returns {ReactElement} O elemento React renderizado que representa o wrapper de abas.
 */
function TabContent({ children, padding = 3 }) {
  return (
    <div className={`tab-content p-${padding} text-muted`} id="tabs-content">
      {children}
    </div>
  );
}

TabContent.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.number,
};

export default TabContent;
